// extracted by mini-css-extract-plugin
export default {"labels":"DateFilterControl_labels__buMUY"};